<template>
    <modal :ifPrevopen="ifPrevopen" :ifNextopen="ifNextopen" @prevOpen="prevOpen" @nextOpen="nextOpen" :title="$t('Updates')" @close="$emit('close')" :key="this.componentKey">
        <template v-slot:head-button>
            <!-- <div class="dropdown" v-if="perms[421]">
                <button class="btn btn-ghost-secondary btn-icon btn-sm fs-16" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="bx bx-dots-vertical-rounded align-bottom"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-end">
                    <button class="dropdown-item" v-if="perms[421]" @click="createEvent">{{ $t('addToCalendar') }}</button>
                </div>
            </div> -->
        </template>
        <template v-slot:body>

            <b-row>
                <b-col>
                    <div>
                        <b-tabs pills >
                            <b-tab >
                                <template #title>
                                    <span class="d-block d-sm-none"><i class="ri-information-line"></i></span>
                                    <span class="d-none d-sm-block">{{ $t('AbouttheUpdate') }}</span> 
                                </template>
                                <div class="mt-1">
                                    
                                    <b-row>
                                        <b-col>
                                            <b-card>
                                                <div class="d-flex">
                                                    <div class="flex-grow-1 click" >
                                                        <h4><b>{{this.mutateUpdate(form.update)}}</b> <span :class="`fs-14 ${mutateStatus(form.status).color}`">{{ mutateStatus(form.status).name }}</span></h4>
                                                        <p class="text-muted mb-0"><b>{{ $t('version') }}</b>: {{form.version}}</p>
                                                        <p class="text-muted"><b>{{ $t('deadLine') }}</b>: {{form.deadlineDate}}</p>
                                                    </div>
                                                    <div class="flex-shrink-0 d-flex align-items-start gap-2">
                                                        <!-- Копіювати повне оновлення (заголовок + перелік пунктів) -->
                                                        <button
                                                            @click="copyFullUpdate()"
                                                            class="btn btn-soft-info copy-update-btn"
                                                            :title="$t('copyUpdate')"
                                                        >
                                                            <i class="ri-clipboard-line align-bottom copy-update-btn-icon"></i><span class="copy-update-btn-text">{{ $t('copyUpdate') }}</span>
                                                        </button>
                                                        <div v-if="perms[372] || perms[2000]">
                                                            <button
                                                                v-if="perms[372] || perms[2000]"
                                                                @click="showModal = true"
                                                                class="btn btn-light"
                                                                data-bs-toggle="tooltip"
                                                                data-bs-placement="top"
                                                                title="Edit"
                                                            >
                                                            <i class="ri-pencil-fill align-bottom"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <template v-if="form.comment">

                                                    <hr />

                                                    <h5 class="text-left"><b>{{$t('desc')}}</b></h5>

                                                    <div class="ql-container">
                                                        <div class="ql-editor" v-html="form.comment">
                                                        </div>
                                                    </div>

                                                </template>

                                            </b-card>
                                        </b-col>
                                    </b-row>

                                    <b-card>

                                        <h5 class="fw-semibold text-uppercase mb-3 border-bottom pb-3">🔥 {{ $t('NewOpportunities') }}</h5>

                                        <template
                                            v-if="form.opportunities.length > 0"
                                            v-for="(item, index) in this.form.opportunities"
                                            :key="index"
                                        >
                                            <!-- Пункт-тікет (класифікований за типом рішення) -->
                                            <div v-if="item.entryType == 'ticket'" :class="`d-flex align-items-center border border-dashed p-2 rounded mb-2 mt-1 ${item.testedInPreRelease ? 'row-tested-in-prerelease' : 'row-not-tested-in-prerelease'}`" >
                                                <span class="badge bg-info fs-14">#{{ item.ticketId }}</span>
                                                <div class="flex-grow-1 ms-3 copy" @click="openTicket(item)">
                                                    <h5 class="mb-1">{{ item.ticketName }}</h5>
                                                    <span :class="`fs-12 ${mutateDecidedStatus(item.decidedStatus).color}`">{{ mutateDecidedStatus(item.decidedStatus).name }}</span>
                                                </div>
                                                <div class="hstack gap-3 fs-16" >
                                                    <!-- Протестовано у предрелізі -->
                                                    <div class="d-flex align-items-center gap-1">
                                                        <span class="fs-11 text-muted">{{ $t('testedInPreRelease') }}</span>
                                                        <div class="form-check form-switch mb-0" :title="$t('testedInPreRelease')">
                                                            <input
                                                                class="form-check-input"
                                                                type="checkbox"
                                                                role="switch"
                                                                :checked="item.testedInPreRelease"
                                                                @change="toggleTestedInPreRelease(item, 'opportunities')"
                                                            >
                                                        </div>
                                                    </div>

                                                    <!-- Змінити оновлення (дедлайн/тип рішення) тікета без відкриття модалки тікета -->
                                                    <button
                                                        v-if="(perms[372] && perms[371]) || perms[2000]"
                                                        @click="openEditDeadlineForTicket(item)"
                                                        class="copy btn btn-soft-warning btn-icon"
                                                        :title="$t('editDeadline')"
                                                    >
                                                        <i class="ri-calendar-event-line"></i>
                                                    </button>

                                                    <!-- Відкрити тікет -->
                                                    <button
                                                        @click="openTicket(item)"
                                                        class="copy btn btn-soft-secondary btn-icon"
                                                    >
                                                        <i class="ri-eye-line"></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <!-- Звичайний вільнотекстовий пункт -->
                                            <div v-else :class="`d-flex align-items-center border border-dashed p-2 rounded mb-2 mt-1 ${item.testedInPreRelease ? 'row-tested-in-prerelease' : 'row-not-tested-in-prerelease'}`" >
                                                <div class="avatar-xs copy" @click="getElement(item, 'opportunities', 'open')">
                                                    <div class="avatar-title badge bg-soft-success text-success rounded fs-16" >{{ index+1 }}</div>
                                                </div>
                                                <div class="flex-grow-1 ms-3 copy" @click="getElement(item, 'opportunities', 'open')">
                                                    <h5 class="mb-1">{{ item.text }}</h5>
                                                </div>
                                                <div class="hstack gap-3 fs-16" >

                                                    <!-- Протестовано у предрелізі -->
                                                    <div
                                                        v-if="perms[372] || perms[2000]"
                                                        class="d-flex align-items-center gap-1"
                                                    >
                                                        <span class="fs-11 text-muted">{{ $t('testedInPreRelease') }}</span>
                                                        <div class="form-check form-switch mb-0" :title="$t('testedInPreRelease')">
                                                            <input
                                                                class="form-check-input"
                                                                type="checkbox"
                                                                role="switch"
                                                                :checked="item.testedInPreRelease"
                                                                @change="toggleTestedInPreRelease(item, 'opportunities')"
                                                            >
                                                        </div>
                                                    </div>

                                                    <!-- Видалити пункт -->
                                                    <button
                                                        v-if="perms[372] || perms[2000]"
                                                        @click="showRemoveItem.item = item.opportunityId; showRemoveItem.show = true; showRemoveItem.type = 'opportunities'"
                                                        class="copy btn btn-soft-danger btn-icon"
                                                    >
                                                        <i class="bx bx-trash"></i>
                                                    </button>

                                                    <!-- Відредагувати пункт -->
                                                    <button
                                                        v-if="perms[372] || perms[2000]"
                                                        @click="getElement(item, 'opportunities', 'edit')"
                                                        class="copy btn btn-soft-dark btn-icon"
                                                    >
                                                        <i class="ri-pencil-fill"></i>
                                                    </button>

                                                    <!-- Скопіювати пункт -->
                                                    <button
                                                        @click="copy(item, 'item')"
                                                        class="copy btn btn-soft-info btn-icon"
                                                    >
                                                        <i class="ri-file-copy-2-line"></i>
                                                    </button>

                                                    <!-- Відкрити детальне вікно -->
                                                    <button
                                                        @click="getElement(item, 'opportunities', 'open')"
                                                        class="copy btn btn-soft-secondary btn-icon"
                                                    >
                                                        <i class="ri-eye-line"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </template>
                                        
                                        <template v-else>
                                            <div
                                                class="border border-dashed p-2 rounded mb-2 mt-1 text-center" 
                                            >
                                                <span class="fs-14">{{ $t('NonewFeaturesBeenAdded') }}</span>
                                            </div>
                                        </template>

                                        <div class="d-flex mt-2" >

                                            <!-- Копіювати -->
                                            <button 
                                                @click="copy(form.opportunities, 'items', '🔥 Нові можливості')"
                                                v-if="form.opportunities.length > 0"
                                                type="button" 
                                                :class="`btn btn-soft-secondary `"
                                                :title="$t('toCopy')" 
                                                style="margin-top: 10px;margin-right: 5px;"
                                            >
                                                <i class="ri-file-copy-2-line align-bottom"></i>
                                            </button>

                                            <!-- Кнопка додавання опису -->
                                            <button 
                                                v-if="perms[372] || perms[2000]"
                                                @click="openEditModal('opportunities')" 
                                                type="button" 
                                                class="mt-2 btn btn-soft-info waves-effect waves-light w-100 fw-semibold"
                                            >
                                               {{ $t('AddnewFeatures') }}
                                            </button>
                                        </div>
                                    </b-card>

                                    <b-card>
                                        <h5 class="fw-semibold text-uppercase mb-3 border-bottom pb-3">🙌 {{ $t('Improved') }}</h5>
                                        
                                        <template
                                            v-if="form.improvements.length > 0"
                                            v-for="(item, index) in this.form.improvements"
                                            :key="index"
                                        >
                                            <!-- Пункт-тікет (класифікований за типом рішення) -->
                                            <div v-if="item.entryType == 'ticket'" :class="`d-flex align-items-center border border-dashed p-2 rounded mb-2 mt-1 ${item.testedInPreRelease ? 'row-tested-in-prerelease' : 'row-not-tested-in-prerelease'}`" >
                                                <span class="badge bg-info fs-14">#{{ item.ticketId }}</span>
                                                <div class="flex-grow-1 ms-3 copy" @click="openTicket(item)">
                                                    <h5 class="mb-1">{{ item.ticketName }}</h5>
                                                    <span :class="`fs-12 ${mutateDecidedStatus(item.decidedStatus).color}`">{{ mutateDecidedStatus(item.decidedStatus).name }}</span>
                                                </div>
                                                <div class="hstack gap-3 fs-16" >
                                                    <!-- Протестовано у предрелізі -->
                                                    <div class="d-flex align-items-center gap-1">
                                                        <span class="fs-11 text-muted">{{ $t('testedInPreRelease') }}</span>
                                                        <div class="form-check form-switch mb-0" :title="$t('testedInPreRelease')">
                                                            <input
                                                                class="form-check-input"
                                                                type="checkbox"
                                                                role="switch"
                                                                :checked="item.testedInPreRelease"
                                                                @change="toggleTestedInPreRelease(item, 'improvements')"
                                                            >
                                                        </div>
                                                    </div>

                                                    <!-- Змінити оновлення (дедлайн/тип рішення) тікета без відкриття модалки тікета -->
                                                    <button
                                                        v-if="(perms[372] && perms[371]) || perms[2000]"
                                                        @click="openEditDeadlineForTicket(item)"
                                                        class="copy btn btn-soft-warning btn-icon"
                                                        :title="$t('editDeadline')"
                                                    >
                                                        <i class="ri-calendar-event-line"></i>
                                                    </button>

                                                    <!-- Відкрити тікет -->
                                                    <button
                                                        @click="openTicket(item)"
                                                        class="copy btn btn-soft-secondary btn-icon"
                                                    >
                                                        <i class="ri-eye-line"></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <!-- Звичайний вільнотекстовий пункт -->
                                            <div v-else :class="`d-flex align-items-center border border-dashed p-2 rounded mb-2 mt-1 ${item.testedInPreRelease ? 'row-tested-in-prerelease' : 'row-not-tested-in-prerelease'}`" >
                                                <div class="avatar-xs copy" @click="getElement(item, 'improvements', 'open')">
                                                    <div class="avatar-title badge bg-soft-success text-success rounded fs-16" >{{ index+1 }}</div>
                                                </div>
                                                <div class="flex-grow-1 ms-3 copy" @click="getElement(item, 'improvements', 'open')">
                                                    <h5 class="mb-1">{{ item.text }}</h5>
                                                </div>
                                                <div class="hstack gap-3 fs-16" >

                                                    <!-- Протестовано у предрелізі -->
                                                    <div
                                                        v-if="perms[372] || perms[2000]"
                                                        class="d-flex align-items-center gap-1"
                                                    >
                                                        <span class="fs-11 text-muted">{{ $t('testedInPreRelease') }}</span>
                                                        <div class="form-check form-switch mb-0" :title="$t('testedInPreRelease')">
                                                            <input
                                                                class="form-check-input"
                                                                type="checkbox"
                                                                role="switch"
                                                                :checked="item.testedInPreRelease"
                                                                @change="toggleTestedInPreRelease(item, 'improvements')"
                                                            >
                                                        </div>
                                                    </div>

                                                    <!-- Видалити пункт -->
                                                    <button
                                                        v-if="perms[372] || perms[2000]"
                                                        @click="showRemoveItem.item = item.improvementId; showRemoveItem.show = true; showRemoveItem.type = 'improvements'"
                                                        class="copy btn btn-soft-danger btn-icon"
                                                    >
                                                        <i class="bx bx-trash"></i>
                                                    </button>

                                                    <!-- Відредагувати пункт -->
                                                    <button
                                                        v-if="perms[372] || perms[2000]"
                                                        @click="getElement(item, 'improvements', 'edit')"
                                                        class="copy btn btn-soft-dark btn-icon"
                                                    >
                                                        <i class="ri-pencil-fill"></i>
                                                    </button>

                                                    <!-- Скопіювати пункт -->
                                                    <button
                                                        class="copy btn btn-soft-info btn-icon"
                                                        @click="copy(item, 'item')"
                                                    >
                                                        <i class="ri-file-copy-2-line"></i>
                                                    </button>

                                                    <!-- Відкрити детальне вікно -->
                                                    <button
                                                        @click="getElement(item, 'improvements', 'open')"
                                                        class="copy btn btn-soft-secondary btn-icon"
                                                    >
                                                        <i class="ri-eye-line"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </template>
                                        
                                        <template v-else>
                                            <div
                                                class="border border-dashed p-2 rounded mb-2 mt-1 text-center" 
                                            >
                                                <span class="fs-14">{{ $t('NoImprovementItemsAdded') }}</span>
                                            </div>
                                        </template>

                                        <div class="d-flex mt-2" >

                                            <button 
                                                v-if="form.improvements.length > 0"
                                                @click="copy(form.improvements, 'items', '🙌 Покращено')"
                                                type="button" 
                                                :class="`btn btn-soft-secondary `"
                                                :title="$t('toCopy')" 
                                                style="margin-top: 10px;margin-right: 5px;"
                                            >
                                                <i class="ri-file-copy-2-line align-bottom"></i>
                                            </button>

                                            <!-- Кнопка додавання опису -->
                                            <button 
                                                v-if="perms[372] || perms[2000]"
                                                @click="openEditModal('improvements')" 
                                                type="button" 
                                                class="mt-2 btn btn-soft-info waves-effect waves-light w-100 fw-semibold" 
                                            >
                                                {{ $t('AddImprovements') }}
                                            </button>
                                        </div>

                                    </b-card>

                                    <b-card>
                                        <h5 class="fw-semibold text-uppercase mb-3 border-bottom pb-3">💪 {{ $t('Corrected') }}</h5>
                                        
                                        <template
                                            v-if="form.fixed.length > 0"
                                            v-for="(item, index) in this.form.fixed"
                                            :key="index"
                                        >
                                            <!-- Пункт-тікет (класифікований за типом рішення) -->
                                            <div v-if="item.entryType == 'ticket'" :class="`d-flex align-items-center border border-dashed p-2 rounded mb-2 mt-1 ${item.testedInPreRelease ? 'row-tested-in-prerelease' : 'row-not-tested-in-prerelease'}`" >
                                                <span class="badge bg-info fs-14">#{{ item.ticketId }}</span>
                                                <div class="flex-grow-1 ms-3 copy" @click="openTicket(item)">
                                                    <h5 class="mb-1">{{ item.ticketName }}</h5>
                                                    <span :class="`fs-12 ${mutateDecidedStatus(item.decidedStatus).color}`">{{ mutateDecidedStatus(item.decidedStatus).name }}</span>
                                                </div>
                                                <div class="hstack gap-3 fs-16" >
                                                    <!-- Протестовано у предрелізі -->
                                                    <div class="d-flex align-items-center gap-1">
                                                        <span class="fs-11 text-muted">{{ $t('testedInPreRelease') }}</span>
                                                        <div class="form-check form-switch mb-0" :title="$t('testedInPreRelease')">
                                                            <input
                                                                class="form-check-input"
                                                                type="checkbox"
                                                                role="switch"
                                                                :checked="item.testedInPreRelease"
                                                                @change="toggleTestedInPreRelease(item, 'fixed')"
                                                            >
                                                        </div>
                                                    </div>

                                                    <!-- Змінити оновлення (дедлайн/тип рішення) тікета без відкриття модалки тікета -->
                                                    <button
                                                        v-if="(perms[372] && perms[371]) || perms[2000]"
                                                        @click="openEditDeadlineForTicket(item)"
                                                        class="copy btn btn-soft-warning btn-icon"
                                                        :title="$t('editDeadline')"
                                                    >
                                                        <i class="ri-calendar-event-line"></i>
                                                    </button>

                                                    <!-- Відкрити тікет -->
                                                    <button
                                                        @click="openTicket(item)"
                                                        class="copy btn btn-soft-secondary btn-icon"
                                                    >
                                                        <i class="ri-eye-line"></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <!-- Звичайний вільнотекстовий пункт -->
                                            <div v-else :class="`d-flex align-items-center border border-dashed p-2 rounded mb-2 mt-1 ${item.testedInPreRelease ? 'row-tested-in-prerelease' : 'row-not-tested-in-prerelease'}`" >
                                                <div class="avatar-xs copy" @click="getElement(item, 'fixed', 'open')">
                                                    <div class="avatar-title badge bg-soft-success text-success rounded fs-16" >{{ index+1 }}</div>
                                                </div>
                                                <div class="flex-grow-1 ms-3 copy" @click="getElement(item, 'fixed', 'open')">
                                                    <h5 class="mb-1">{{ item.text }}</h5>
                                                </div>
                                                <div class="hstack gap-3 fs-16" >

                                                    <!-- Протестовано у предрелізі -->
                                                    <div
                                                        v-if="perms[372] || perms[2000]"
                                                        class="d-flex align-items-center gap-1"
                                                    >
                                                        <span class="fs-11 text-muted">{{ $t('testedInPreRelease') }}</span>
                                                        <div class="form-check form-switch mb-0" :title="$t('testedInPreRelease')">
                                                            <input
                                                                class="form-check-input"
                                                                type="checkbox"
                                                                role="switch"
                                                                :checked="item.testedInPreRelease"
                                                                @change="toggleTestedInPreRelease(item, 'fixed')"
                                                            >
                                                        </div>
                                                    </div>

                                                    <!-- Видалити пункт -->
                                                    <button
                                                        v-if="perms[372] || perms[2000]"
                                                        @click="showRemoveItem.item = item.fixedId; showRemoveItem.show = true; showRemoveItem.type = 'fixed'"
                                                        class="copy btn btn-soft-danger btn-icon"
                                                    >
                                                        <i class="bx bx-trash"></i>
                                                    </button>

                                                    <!-- Відредагувати пункт -->
                                                    <button
                                                        v-if="perms[372] || perms[2000]"
                                                        @click="getElement(item, 'fixed', 'edit')"
                                                        class="copy btn btn-soft-dark btn-icon"
                                                    >
                                                        <i class="ri-pencil-fill"></i>
                                                    </button>

                                                    <!-- Скопіювати пункт -->
                                                    <button
                                                        class="copy btn btn-soft-info btn-icon"
                                                        @click="copy(item, 'item')"
                                                    >
                                                        <i class="ri-file-copy-2-line"></i>
                                                    </button>

                                                    <!-- Відкрити детальне вікно -->
                                                    <button
                                                        @click="getElement(item, 'fixed', 'open')"
                                                        class="copy btn btn-soft-secondary btn-icon"
                                                    >
                                                        <i class="ri-eye-line"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </template>
                                        
                                        <template v-else>
                                            <div
                                                class="border border-dashed p-2 rounded mb-2 mt-1 text-center" 
                                            >
                                                <span class="fs-14">{{ $t('NofixItemsAdded') }}</span>
                                            </div>
                                        </template>

                                        <div class="d-flex mt-2" >

                                            <!-- Копіюватит -->
                                            <button 
                                                v-if="form.fixed.length > 0"
                                                 @click="copy(form.fixed, 'items', '💪 Виправлено')"
                                                type="button" 
                                                :class="`btn btn-soft-secondary `"
                                                :title="$t('toCopy')" 
                                                style="margin-top: 10px;margin-right: 5px;"
                                            >
                                                <i class="ri-file-copy-2-line align-bottom"></i>
                                            </button>

                                            <!-- Кнопка додавання опису -->
                                            <button 
                                                v-if="perms[372] || perms[2000]"
                                                @click="openEditModal('fixed')" 
                                                type="button" 
                                                class="mt-2 btn btn-soft-info waves-effect waves-light w-100 fw-semibold" 
                                            >
                                                {{ $t('Addcorrections') }}
                                            </button>
                                        </div>
                                    </b-card>


                                </div>
                            </b-tab>
                            <b-tab v-if="this.form.projects.length > 0">
                                <template #title>
                                    <span class="d-block d-sm-none"><i class="ri-task-line"></i></span>
                                    <span class="d-none d-sm-block">{{ $t('navProjects') }}</span> 
                                </template>
                                <div class="mt-1"><projects :obj="this.form.projects" /> </div>
                            </b-tab>
                            <b-tab v-if="this.form.tickets.length > 0" >
                                <template #title>
                                    <span class="d-block d-sm-none"><i class="ri-task-line"></i></span>
                                    <span class="d-none d-sm-block">{{ $t('tickets') }}</span> 
                                </template>
                                <div class="mt-1"><tickets :obj="this.form.tickets" /> </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </b-col>
            </b-row>

        </template>
        <template v-slot:footer-bottom>
            <!-- <button class="btn link-success fw-medium"  @click="$emit('close')"><i class="ri-close-line me-1 align-middle"></i>{{ $t('close') }}</button> -->
            <button 
                type="button" 
                v-if="perms[373] || perms[2000]"
                @click="dialogShow = true" 
                class="btn btn-danger r waves-effect waves-light">
                {{ $t('Delete') }}
            </button>
            <button class="btn btn-warning r waves-effect waves-light" 
                @click="this.startEdit('projects')"
                v-if="((perms[372] || perms[2000]) &&
                    (this.form.status != 'pre_release' && this.form.status != 'in_release'))
                "
            >
                {{ $t('pre_release') }}
            </button>
            <button class="btn btn-success r waves-effect waves-light" 
                @click="goInRelease"
            >
                {{ $t('inRelease') }}
            </button>
        </template>
    </modal>

    <editdesc v-if="showModal" @close="showModal = false" :obj="this.form" />

    <!-- событие в календарь -->
    <addEvent
        v-if="showAddEvent"
        @close="showAddEvent = false"
        :crItem="crItem"
        @updateCard="updateCard"
    />
    <!-- событие в календарь -->

    <modalremove 
        v-if="dialogShow" 
        @close="dialogShow = false" 
        @remove="toDelete()" 
    />

    <editWindow 
        v-if="this.showEdit == true" 
        @close="this.showEdit = false" 
        :items="this.items" 
        :itemsTickets="itemsTickets" 
        :objdata="this.rows" 
        :id="form.deadlineId" 
        :form="this.form" 
        @getdata="this.updateCard(); this.$emit('getdata')"
    ></editWindow>

    <!-- Модальне вікно додавання/редагування пунктів -->
    <editItems 
        v-if="showEditItems.show"
        @close="closeEditModal"
        :objCard="this.form"
        :type="showEditItems.type"
    />

    <!-- Модальне вікно редагування з деталями по пункту -->
    <editElement 
        v-if="showEditModal.show"
        @close="showEditModal.show = false; this.updateCard()"
        :objCard="this.objCard"
        :objElement="this.showEditModal.dataElement"
        :type="showEditModal.type"
    />

    <!-- Модальне вікно з деталями по пункту -->
    <viewItem 
        v-if="showItemModal.show"
        @close="showItemModal.show = false"
        :objCard="showItemModal.obj"
        :type="showItemModal.type"
        :deadlineId="form.deadlineId"
        :objForm="this.form"
    />

    <!-- Модальне вікно з підтвердженням видалення пункту -->
    <removeBox
        v-if="showRemoveItem.show"
        @close="showRemoveItem.show = false"
        @deleteItem="removeItem();showRemoveItem.show = false"
    />

    <!-- Модальне вікно перегляду тікета, класифікованого в списку -->
    <viewbox
        v-if="modalShowview == true"
        @close="modalShowview = false"
        :obj="this.objTicket"
    ></viewbox>

    <!-- Модальне вікно зміни оновлення (дедлайну/типу рішення) тікета, класифікованого в списку -->
    <editDeadline
        v-if="showEditDeadlineForTicket == true"
        @close="showEditDeadlineForTicket = false; this.updateCard()"
        :obj="this.ticketForDeadlineEdit"
    ></editDeadline>

</template>

<script>
import editWindow from '../delcategmodal.vue'
import modal from '@/components/modal/modal-lg'
import editdesc from './editdesc'
import projects from './projects'
import tickets from './tickets.vue';
import addEvent from '@/components/calendar/addEvent'
import modalremove from '@/components/modal/modalremove'
import { Updates, Tickets } from '@/API.js'
import { storeS } from '@/store';
import { mutateStatusUpdates, mutateDecidedStatusTicket } from '@/usabilityScripts/globalMutate.js'
import editItems from './editItem/editItems.vue'; // модальне вікно додавання/редагування пунктів
import editElement from './editItem/index.vue' // модальне вікно додавання/редагування детальної інформації по пункту
import viewItem from './viewItem/index'; // модальне вікно перегляду детальної інформації по пункту
import removeBox from './action/removeItem'  // модальне вікно підтвердження видалення детальної інформації по пункту
import viewbox from '@/views/newtickets/view/index.vue' // модальне вікно перегляду тікета
import editDeadline from '@/views/newtickets/view/actions/editDeadline.vue' // модальне вікно зміни оновлення (дедлайну) тікета
import { sendTelegramMessage } from '@/usabilityScripts/logsTelegram.js' // надсилання логу в телеграм

let apiUpdates = new Updates();
let apiTickets = new Tickets();

export default{
    props: ['objCard', 'ifPrevopen', 'ifNextopen', 'rows'],
    components: {
        modal,
        projects,
        tickets,
        editdesc,
        addEvent,
        editWindow,
        modalremove,
        editItems,
        editElement,
        viewItem,
        removeBox,
        viewbox,
        editDeadline
    },
    data(){
        return{
            componentKey: 0,
            modalShowview: false, // відображення вікна тікету
            objTicket: '', // дані тікету, класифікованого в списку
            showEditDeadlineForTicket: false, // відображення вікна зміни оновлення тікета
            ticketForDeadlineEdit: '', // дані тікету для зміни оновлення (дедлайну)
            dialogShow: false,
            items: [],
            itemsTickets: [],
            showEdit: false,
            showAddEvent: false,
            crItem: {
                id: '',
                type: 'deadline',
                name: '',
                description: '',
                date: '',
                time: ''
            },
            form:"",
            showModal: "",
            boxprojects: false,
            boxtickets: false,
            projects:{},
            tickets: {},
            showEditItems: { // налаштування по редагуванню пукнтів
                data: {},
                show: false,
                type: ''
            },
            showEditModal: { // налаштування по редагуванню пункта
                dataElement: '',
                show: false,
                type: ''
            },
            showItemModal: { // налаштування на перегляд пункта
                obj: '',
                show: false,
                type: ''
            },
            showRemoveItem: { // налаштування на видалення пункту
                show: false,
                item: '',
                type: ''
            },
        }
    },
    created(){
        this.getdata();
    },
    methods: {
        mutateUpdate(e) {
            return this.developmentProjects.find(el => el.projectKey === e).projectName
        },
        prevOpen(){
            this.$emit('close');
            this.$emit('prevOpen', this.form.deadlineId)
        },
        nextOpen(){
            this.$emit('close');
            this.$emit('nextOpen', this.form.deadlineId)
        },
        goInRelease() {
            let obj ={
                status: "in_release"
            }
            apiUpdates.deadlineStatus(this.form.deadlineId, obj).then(result => {
                if(result.status == 'done') {
                    this.$toast.success(this.$t('success'))
                    this.$emit('getdata')
                    this.$emit('close')
                } else {
                    this.$toast.error(this.$t('error'))
                }
            })
        },
        updateCard(){
            // Оновлення картки
            apiUpdates.getUpdate(this.form.deadlineId).then(result => {
                if(result.status == 'done'){
                    this.form = result.data
                    this.componentKey++
                }
            })
        },
        startEdit(a) {
            // if(a == 'tickets') {
            //     this.items = this.form.tickets
            // } else {
            //     this.items = this.form.projects
            // }
            this.items = this.form.projects;
            this.itemsTickets = this.form.tickets;
            this.showEdit = true
        },
        getdata(){
            this.form = this.objCard
        },
        toDelete(){
            // Видалення оновлення
            apiUpdates.deleteUpdate(this.form.deadlineId).then(result => {
                if(result.status == 'done'){
                    this.$toast.success(this.$t('Removed'));
                    this.eventBus.emit('saveUpdate', true)
                    this.$emit('close')
                } else {
                    this.$toast.error(this.$t('error'));
                }
            })
        },
        prevOpen(){
            this.$emit('close');
            this.$emit('prevOpen', this.form.deadlineId)
        },
        nextOpen(){
            this.$emit('close');
            this.$emit('nextOpen', this.form.deadlineId)
        },
        // createEvent(){
        //     this.crItem.date = this.form.deadlineDate;
        //     this.crItem.time = '10:00';
        //     this.crItem.name = this.mutateName(this.form.update);
        //     this.crItem.description = '';
        //     this.showAddEvent = true;
        // },
        // mutateName(e){
        //     return mutateUpdate(e)
        // },
        mutateStatus(item) {
            return mutateStatusUpdates(item)
        },
        mutateDecidedStatus(item) {
            return mutateDecidedStatusTicket(item)
        },
        openTicket(item){
            // Відкрити вікно деталей тікета, класифікованого в списку

            apiTickets.getTicket(item.ticketId).then(result => {
                if(result.status == 'done'){
                    this.objTicket = result.data;
                    this.modalShowview = true;
                }
            })
        },
        openEditDeadlineForTicket(item){
            // Відкрити вікно зміни оновлення (дедлайну/типу рішення) тікета, класифікованого в списку, без відкриття модалки тікета

            apiTickets.getTicket(item.ticketId).then(result => {
                if(result.status == 'done'){
                    this.ticketForDeadlineEdit = result.data;
                    this.showEditDeadlineForTicket = true;
                } else {
                    this.$toast.error(this.$t('error'));
                }
            })
        },
        toggleTestedInPreRelease(entry, listType){
            // Перемикач "протестовано у предрелізі" для пункту списку (тікет або вільнотекстовий пункт)

            var value = !entry.testedInPreRelease;
            var obj = { testedInPreRelease: value };
            var call;

            if(entry.entryType == 'ticket') {
                call = apiTickets.setTestedInPreRelease(entry.ticketId, obj)
            } else if(listType == 'opportunities') {
                call = apiUpdates.setTestedInPreReleaseOpportunity(entry.opportunityId, obj)
            } else if(listType == 'improvements') {
                call = apiUpdates.setTestedInPreReleaseImprovement(entry.improvementId, obj)
            } else {
                call = apiUpdates.setTestedInPreReleaseFixed(entry.fixedId, obj)
            }

            call.then(result => {
                if(result.status == 'done') {
                    entry.testedInPreRelease = value;
                } else {
                    this.$toast.error(this.$t('error'));
                }
            })
        },
        openEditModal(type) {
            this.showEditItems.type = type; // встановлюємо тип
            this.showEditItems.data = {}; // очищаємо або встановлюємо початкові дані
            this.showEditItems.show = true; // відкриваємо модальне вікно
        },
        closeEditModal(array, type) {
            switch(type) {
                case 'opportunities':
                    this.form.opportunities = array
                break;

                case 'improvements': 
                    this.form.improvements = array
                break;

                case 'fixed': 
                    this.form.fixed = array
                break;
            }
            this.showEditItems.show = false; // закриваємо модальне вікно
            this.updateCard(); // викликаємо оновлення після закриття
            // this.changCard(this.form); // викликаємо оновлення після закриття
        },
        changCard(form){
            apiUpdates.editUpdate(form.deadlineId, form).then(result => {
                if(result.status === 'done') {
                    this.$toast.success(this.$t('success'))
                    this.updateCard()
                } else {
                    // todo logs
                }
            })
        },
        removeItem(){
            // Видалити елемент

            switch (this.showRemoveItem.type) {

                case 'opportunities': 

                    apiUpdates.deleteOpportunity(this.showRemoveItem.item).then(result => {

                        if(result.status == 'done') {
                            this.form.opportunities = result.data;
                            this.$toast.success(this.$t("Removed"))
                        } else {
                            this.$toast.error(this.$t('error') + " " + result.error[0]);

                            // sendTelegramMessage
                            var errorText = 'Помилка видалення пункту нових можливостей'; 
                            var statusRequest = result.status;
                            var api = 'deleteOpportunity';
                            var fileRequest = 'src/views/changelog/view/index.vue';
                            var params = this.showRemoveItem.item;
                            var response = result

                            // Викликаємо функцію для відправки повідомлення в телеграм
                            sendTelegramMessage(errorText, statusRequest, api, fileRequest, params, response)
                            .then(response => console.log('Telegram API response:', response.data))
                            .catch(error => console.error('Telegram API error:', error));
                        }

                    })

                break;
                case 'improvements': 

                    apiUpdates.deleteImprovement(this.showRemoveItem.item).then(result => {

                        if(result.status == 'done') {
                            this.form.improvements = result.data;
                            this.$toast.success(this.$t("Removed"))
                        } else {
                            this.$toast.error(this.$t('error') + " " + result.error[0]);

                            // sendTelegramMessage
                            var errorText = 'Помилка видалення пункту покращення'; 
                            var statusRequest = result.status;
                            var api = 'deleteImprovement';
                            var fileRequest = 'src/views/changelog/view/index.vue';
                            var params = this.showRemoveItem.item;
                            var response = result

                            // Викликаємо функцію для відправки повідомлення в телеграм
                            sendTelegramMessage(errorText, statusRequest, api, fileRequest, params, response)
                            .then(response => console.log('Telegram API response:', response.data))
                            .catch(error => console.error('Telegram API error:', error));
                        }

                    })

                break;
                case 'fixed': 

                    apiUpdates.deleteFixed(this.showRemoveItem.item).then(result => {

                        if(result.status == 'done') {
                            this.form.fixed = result.data;
                            this.$toast.success(this.$t("Removed"))
                        } else {
                            this.$toast.error(this.$t('error') + " " + result.error[0]);

                            // sendTelegramMessage
                            var errorText = 'Помилка видалення пункту виправлення'; 
                            var statusRequest = result.status;
                            var api = 'deleteFixed';
                            var fileRequest = 'src/views/changelog/view/index.vue';
                            var params = this.showRemoveItem.item;
                            var response = result

                            // Викликаємо функцію для відправки повідомлення в телеграм
                            sendTelegramMessage(errorText, statusRequest, api, fileRequest, params, response)
                            .then(response => console.log('Telegram API response:', response.data))
                            .catch(error => console.error('Telegram API error:', error));
                        }

                    })

                break;

                default: 
                    this.$toast.error(this.$t('error'));
                break
            }
        },
        getElement(item, type, method) {
            // Отримати або відредагувати пункт
            
            switch (type) {

                case 'opportunities': 

                    apiUpdates.getOpportunity(item.opportunityId).then(result => {

                        if(result.status == 'done') {
                            
                            if(method == 'edit'){
                                // Відкриваємо вікно редагування
                                this.showEditModal.type = type;
                                this.showEditModal.dataElement = result.data
                                this.showEditModal.show = true
                            } else {
                                // Відкриваємо вікно перегляду
                                this.showItemModal.obj = result.data
                                this.showItemModal.show = true
                                this.showItemModal.type = type;
                            }
                            
                        } else {
                            console.log(result);
                        }

                    })

                break;
                case 'improvements': 

                    apiUpdates.getImprovement(item.improvementId).then(result => {

                        if(result.status == 'done') {
                            
                            if(method == 'edit'){
                                // Відкриваємо вікно редагування
                                this.showEditModal.type = type;
                                this.showEditModal.dataElement = result.data
                                this.showEditModal.show = true
                            } else {
                                // Відкриваємо вікно перегляду
                                this.showItemModal.obj = result.data
                                this.showItemModal.show = true
                                this.showItemModal.type = type;
                            }
                            
                        } else {
                            console.log(result);
                        }

                    })

                break;
                case 'fixed': 

                    apiUpdates.getFixed(item.fixedId).then(result => {

                        if(result.status == 'done') {
                            
                            if(method == 'edit'){
                                // Відкриваємо вікно редагування
                                this.showEditModal.type = type;
                                this.showEditModal.dataElement = result.data
                                this.showEditModal.show = true
                            } else {
                                // Відкриваємо вікно перегляду
                                this.showItemModal.obj = result.data
                                this.showItemModal.show = true
                                this.showItemModal.type = type;
                            }
                            
                        } else {
                            console.log(result);
                        }

                    })

                break;
                    

                default: 
                    console.log('log');
                break

            }
        },
        copy(item, type, sectionText){
            // Копіювати

            console.log("item", item);
            var textCopy = "";
            
            switch (type) {
                case 'item':
                    textCopy = `Пункт "${item.text}"`
                break;

                case 'items':
                    // Створюємо текст для копіювання
                    textCopy = `${sectionText}:\n`;
                    item.forEach((item, index) => {
                        textCopy += `${index + 1}. ${item.entryType == 'ticket' ? item.ticketName : item.text}\n`;
                    });
                break;

                default:
                    console.log('');
                break
                
            }

            navigator.clipboard.writeText(textCopy)
                .then(() => {
                    this.$toast.success(this.$t('Текст скопійовано успішно'))
                })
                .catch(err => {
                    console.error('Помилка при копіюванні:', err);
                });
        },
        copyFullUpdate(){
            // Копіювати повне оновлення: заголовок + секції з переліком пунктів (без статусів та позначки предрелізу)

            var titleSection = { opportunities: 'Нові можливості', improvements: 'Покращено', fixed: 'Виправлено' };

            var textCopy = `${this.mutateUpdate(this.form.update)} ${this.mutateStatus(this.form.status).name}\n`;
            textCopy += `Версія: ${this.form.version}\n`;
            textCopy += `Дедлайн: ${this.form.deadlineDate}\n\n`;

            ['opportunities', 'improvements', 'fixed'].forEach(section => {
                var items = this.form[section];
                textCopy += `${titleSection[section]}:\n`;

                if(!items || items.length == 0) {
                    textCopy += `—\n\n`;
                    return;
                }

                items.forEach((item, index) => {
                    if(item.entryType == 'ticket') {
                        textCopy += `${index + 1}. #${item.ticketId} ${item.ticketName}\n`;
                    } else {
                        textCopy += `${index + 1}. ${item.text}\n`;
                    }
                });

                textCopy += `\n`;
            });

            navigator.clipboard.writeText(textCopy)
                .then(() => {
                    this.$toast.success(this.$t('Текст скопійовано успішно'))
                })
                .catch(err => {
                    console.error('Помилка при копіюванні:', err);
                });
        }
    },
    mounted(){
        this.eventBus.on('saveProject', (status) => {
            if(status == true) {
                this.getdata();
            }
        }),
        this.eventBus.on('saveTicket', (status) => {
            if(status == true) {
                this.getTickets();
            }
        })
    },
    computed: {
        perms(){
            return storeS.perms
        },
        user(){
            return storeS.userbase
        },
        developmentProjects() {
            // Отримання проектів
            return storeS.developmentProjects
        }
    }
}
</script>

<style scoped>
.row-not-tested-in-prerelease {
    background-color: rgba(220, 53, 69, 0.15);
}
.row-tested-in-prerelease {
    background-color: rgba(40, 167, 69, 0.15);
}
.copy-update-btn-icon {
    margin-right: 0.25rem;
}
@media (max-width: 470px) {
    .copy-update-btn-text {
        display: none;
    }
    .copy-update-btn-icon {
        margin-right: 0;
    }
}
</style>